(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-start/assets/react/components/header-text-slider.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-start/assets/react/components/header-text-slider.js');
"use strict";



const {
  useRef,
  useState,
  useEffect
} = React;
const {
  heroSlider: sliderData
} = svs.lyckoplatsen.data.hero;
const HeaderTextSlider = () => {
  var _sliderData$content;
  const slideRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  useEffect(() => {
    if (!Array.isArray(sliderData === null || sliderData === void 0 ? void 0 : sliderData.content) || sliderData.content.length === 0) {
      return;
    }
    const interval = setInterval(() => {
      gsap.to(slideRef.current, {
        x: '-100%',
        opacity: 0,
        duration: 0.5,
        ease: 'power4.out',
        onComplete: () => {
          setCurrentSlide(prevSlide => (prevSlide + 1) % sliderData.content.length);
          gsap.set(slideRef.current, {
            x: '100%'
          });
          gsap.to(slideRef.current, {
            x: '0%',
            opacity: 1,
            duration: 0.5,
            ease: 'power4.out'
          });
        }
      });
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  return React.createElement("div", {
    className: "lp-header-text-slider"
  }, React.createElement("p", {
    className: "f-bold ".concat(sliderData === null || sliderData === void 0 ? void 0 : sliderData.color),
    ref: slideRef
  }, (sliderData === null || sliderData === void 0 || (_sliderData$content = sliderData.content) === null || _sliderData$content === void 0 ? void 0 : _sliderData$content[currentSlide]) || ''));
};
setGlobal('svs.lyckoplatsen.components.page_start.react.components', {
  HeaderTextSlider
});

 })(window);